import FetchService from './base.fetch';

/**
 * 扩展服务
 *
 * @export
 * @class ExtensionService
 */
class ExtensionService {

    /**
     * Creates an instance of ExtensionService.
     * @memberof ExtensionService
     */
    constructor() {
        const apisConfig = {
            getRemoteExts: {
                domain: FetchService.domainconfig.ext,
                method: 'post',
                url: 'ext/list'
            },
            // 适用RC3之后版本
            getNewRemoteExtList: {
                method: 'get',
                url: 'api/mblock/:mblockVersion/ext/:type',
                domain: FetchService.domainconfig.extservice
            },
            // 获取扩展支持版本列表
            getExtVersionList: {
                method: 'get',
                url: 'api/mblock/:mblockVersion/extApi/supportVersion',
                domain: FetchService.domainconfig.extservice
            }
        };

        FetchService.configToRequestAction.call(this, apisConfig, FetchService);
    }
}

export default new ExtensionService();